import { assetUrl } from "../../utils";

export type CardVariant =
  | "plastic-black"
  | "plastic-gold"
  | "plastic-purple"
  | "metal-black"
  | "metal-gold"
  | "metal-purple";

export interface KCard {
  variant: CardVariant;
  name: string;
  cardNumber: string;
  validUntil: string;
  price?: number;
}

export const CARD_DATA: Record<CardVariant, { image: string; price: number }> =
  {
    "plastic-black": {
      image: assetUrl("/card/plastic-black.png"),
      price: 20,
    },
    "plastic-gold": {
      image: assetUrl("/card/plastic-gold.png"),
      price: 40,
    },
    "plastic-purple": {
      image: assetUrl("/card/plastic-purple.png"),
      price: 80,
    },
    "metal-black": {
      image: assetUrl("/card/metal-black.png"),
      price: 40,
    },
    "metal-gold": {
      image: assetUrl("/card/metal-gold.png"),
      price: 60,
    },
    "metal-purple": {
      image: assetUrl("/card/metal-purple.png"),
      price: 100,
    },
  };

export const CARD_VARIANTS = [
  { title: "purple", price: 20 },
  { title: "black", price: 40 },
  { title: "gold", price: 80 },
];
export const CARD_MATERIALS = [
  { title: "plastic", price: 0 },
  { title: "metal", price: 20 },
];
